export default __webpack_public_path__ + "static/media/test-speaker.79c8c7c7.ogg";